import { render, staticRenderFns } from "./SubOrderList.vue?vue&type=template&id=03c5476b&scoped=true&"
import script from "./SubOrderList.vue?vue&type=script&lang=js&"
export * from "./SubOrderList.vue?vue&type=script&lang=js&"
import style0 from "./SubOrderList.vue?vue&type=style&index=0&id=03c5476b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c5476b",
  null
  
)

/* custom blocks */
import block0 from "./SubOrderList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports